import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCoupon } from "../../api/apiCoupons";
import { toast } from "react-hot-toast";
import parseError from "../../utils/parseError";

export const useUpdateCoupon = () => {
    const queryClient = useQueryClient();

    const { mutate: updateCouponMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateCoupon(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Coupon updated successfully");
            queryClient.invalidateQueries(["coupons"]);
            queryClient.invalidateQueries(["coupon"]); // invalidate specific coupon details if cached
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update coupon");
        },
    });

    return { updateCouponMutate, isUpdating };
};
